import React from "react";
import './Chart.css';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import translationsJson from 'data/translations.json';
import infoJson from 'data/info.json'
import newbornnamesIndexJson from 'data/newbornNameIndex.json'
import { Person, Sex } from 'lib/Types';


am4core.useTheme(am4themes_animated);

const translations: Translations = translationsJson;
const newbornnamesIndex: any = newbornnamesIndexJson;
const color = {
    m: "#19486a",
    f: "#c5192d"
}

interface Props {
    persons: Person[];
}

class Chart extends React.Component<Props, { dataReady: boolean[] }> {
    private chart: am4charts.XYChart | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            dataReady: new Array<boolean>(this.props.persons.length)
        }
    }

    componentDidMount() {
        this.createGraph();
    }

    private createGraph() {
        const years = [];
        for (let i = infoJson.newbornChartYearRange[0]; i <= infoJson.newbornChartYearRange[1]; i++) {
            years.push(i);
        }

        this.chart = am4core.create("chartdiv", am4charts.XYChart);
        this.chart.paddingRight = 20;

        const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
        //dateAxis.dataFields.date = "date";
        dateAxis.title.text = translations.year[window.lang];
        dateAxis.renderer.grid.template.location = 0;

        const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip!.disabled = true;
        valueAxis.renderer.minWidth = 35;
        this.chart.cursor = new am4charts.XYCursor();

        // legend
        this.chart.legend = new am4charts.Legend();
        this.chart.legend.position = "bottom";
        this.chart.legend.fontWeight = "bold";

        this.chart.zoomOutButton.background.fill = am4core.color("#3b3b3b");
        this.chart.zoomOutButton.background.states.getKey("hover")!.properties.fill = am4core.color("#676767");
        this.chart.zoomOutButton.exportable = false;
        this.chart.zoomOutButton.userClassName = "chart-zoom-button";

        this.chart.data = [];
        for (let i = 0; i < years.length; i++) {
            this.chart.data.push({ date: new Date(years[i], 1, 1) });
        }

        let maleCounter = 0;
        let femaleCounter = 0;
        for (let i = 0; i < this.props.persons.length; i++) {
            const p = this.props.persons[i];
            const series = this.chart.series.push(new am4charts.LineSeries());
            series.tooltip!.getFillFromObject = false;

            if(p.sex! === Sex.Male) {
                series.stroke = am4core.color(color[p.sex!]).lighten(0.1 * maleCounter);
                series.tooltip!.background.fill = am4core.color(color[p.sex!]).lighten(0.1 * maleCounter);
                maleCounter++;
            } else {
                series.stroke = am4core.color(color[p.sex!]).lighten(0.1 * femaleCounter);
                series.tooltip!.background.fill = am4core.color(color[p.sex!]).lighten(0.1 * femaleCounter);
                femaleCounter++;
            }

            series.dataFields.valueY = "name" + i;
            series.dataFields.dateX = "date";
            series.name = p.name + " " + (p.sex === Sex.Male ? "♂" : "♀");
            series.strokeWidth = 2;
            series.tooltipText = "{name}: [bold]{valueY}[/]";

            fetch(`data/newbornnames/${newbornnamesIndex[p.name][p.sex!]}.json`).then(response => response.json()).then(jsonFile => {
                const data = JSON.parse(JSON.stringify(this.chart!.data))
                for (let j = 0; j < data.length; j++) {
                    data[j]["name" + i] = jsonFile[p.name][j];
                }
                const newDataReady = this.state.dataReady;
                newDataReady[i] = true;
                this.chart?.addData(data, data.length);
                this.setState({ dataReady: newDataReady })
            });
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.persons !== this.props.persons) {
            if (this.chart) {
                this.chart.dispose();
            }
            this.createGraph();
        }
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        return (
            <div id="chartdiv" style={{ width: "100%", height: "500px" }}></div>
        );
    }
}

export default Chart;
